import { frontendUrlBuilder } from "utils/routing/frontend-url-builder";

const LEGACY_CATEGORY_PATH = "/blog/category/";

export const isLegacyCategoryCanonical = (canonicalLink?: string): boolean =>
  !!canonicalLink?.includes(LEGACY_CATEGORY_PATH);

export const resolveCategoryCanonical = (canonicalLink: string | undefined, currentPath: string): string => {
  if (canonicalLink && !isLegacyCategoryCanonical(canonicalLink)) {
    return canonicalLink;
  }

  return frontendUrlBuilder.buildCanonicalUrl(currentPath);
};
